import HttpRequest from "../../utilities/httpRequest";
import {
  hideLoader,
  showLoader,
  showSnackbar,
} from "../../utilities/UtilitiesActions";
import {
  addHeadOrg,
  getHeadOrgById,
  getHeadOrgs,
  updateHeadOrg,
} from "./HeadOrgsActions";

/**
 * function to get  organizations
 * @param data: data for api request
 * @param isHideLoader: isHideLoader for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const getHeadOrgsRequest = (data, isHideLoader) => {
  let offset = data.page * data.rowsPerPage;
  let limit = data.rowsPerPage;
  let searchData = data.searchData ? data.searchData : "";

  return (dispatch) => {
    if (!isHideLoader) {
      dispatch(showLoader());
    }

    const url = `org/headOrg?offset=${offset}&limit=${limit}&searchData=${JSON.stringify(
      searchData
    )}`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        dispatch(getHeadOrgs(res?.data.data || []));

        if (!isHideLoader) {
          dispatch(hideLoader());
        }

        return Promise.resolve(res.data.data);
      },
      (error) => {
        if (!isHideLoader) {
          dispatch(hideLoader());
        }

        return Promise.reject(error);
      }
    );
  };
};

/**
 * function to add  organization
 * @param data: data for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const addHeadOrgRequest = (data) => {
  return (dispatch) => {
    dispatch(showLoader());
    const url = "headOrg";

    return new HttpRequest(dispatch, url, "post", data).send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(
          showSnackbar("Head Organization created successfully", "success")
        );

        dispatch(addHeadOrg(res.data.data));
        return Promise.resolve(res.data.data);
      },
      (error) => {
        dispatch(hideLoader());
        if (error.response.data.error) {
          dispatch(showSnackbar(error.response.data.error, "error"));
        }
        return Promise.reject(error);
      }
    );
  };
};

/**
 * function to get organization by id
 * @param id: data for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const getHeadOrgByIdRequest = (id) => {
  return (dispatch) => {
    dispatch(showLoader());

    const url = `org/headOrg/${id}`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(getHeadOrgById(res.data.data));
        return Promise.resolve(res.data.data);
      },
      (error) => {
        dispatch(hideLoader());
        if (error.response.data.error) {
          dispatch(showSnackbar(error.response.data.error, "error"));
        }
        return Promise.reject(error);
      }
    );
  };
};

/**
 * function to update organization
 * @param id: id for api request
 * @param data: data for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const updateOrgRequest = (id, data) => {
  return (dispatch) => {
    dispatch(showLoader());

    const url = `org/headOrg/update/${id}`;

    return new HttpRequest(dispatch, url, "put", data).send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(
          showSnackbar("Head Organization updated successfully", "success")
        );

        dispatch(updateHeadOrg(res.data.data));
        return Promise.resolve(res.data.data);
      },
      (error) => {
        dispatch(hideLoader());
        if (error?.response?.data?.error) {
          dispatch(showSnackbar(error?.response?.data?.error, "error"));
        }
        return Promise.reject(error);
      }
    );
  };
};
